import { render } from "./NcrmRecordHeader.vue?vue&type=template&id=7b6be3d4&scoped=true"
import script from "./NcrmRecordHeader.vue?vue&type=script&lang=js"
export * from "./NcrmRecordHeader.vue?vue&type=script&lang=js"

import "./NcrmRecordHeader.vue?vue&type=style&index=0&id=7b6be3d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6be3d4"]])

export default __exports__